import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase/client';

// Les rôles réellement attribuables sont ceux de la liste ROLES de UserManagement :
// `viewer` (« Lecteur seul ») est le seul rôle en lecture seule.
export type UserRole = 'superadmin' | 'admin' | 'manager' | 'user' | 'viewer' | null

export function useUserRole() {
  const { user } = useAuth()
  const { data: role = null, isLoading } = useQuery({
    queryKey: ['user-role', user?.id],
    queryFn: async (): Promise<UserRole> => {
      if (!user) return null

      try {
        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .limit(1)

        if (error) throw error
        return (data?.[0]?.role as UserRole) ?? null
      } catch (error) {
        console.error('Erreur lors de la récupération du rôle:', error)
        return null
      }
    },
    enabled: !!user,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return { role, loading: !!user && isLoading }
} 
